import { mapGetters } from 'vuex';

export default {
  computed: {
    ...mapGetters({
      sessionTime: 'auth/sessionTime',
    }),
  },
};
